import { Injectable } from '@angular/core';
import { NgbTimeStruct, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class UtilsService {

  constructor() { }

  public guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1).toUpperCase();
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  public getDateFromFirebaseDate(firebaseDate: string) {
    const dateString = firebaseDate.split(', ')[0];
    const day = +dateString.split('/')[0];
    const month = +dateString.split('/')[1];
    const year = +dateString.split('/')[2];

    const timeString = firebaseDate.split(', ')[1];
    const hour = +timeString.split(':')[0];
    const min = +timeString.split(':')[1];

    return new Date(year, month - 1, day, hour, min);
  }

  public getNgbDateFromFirebaseDate(firebaseDate: string): NgbDateStruct {
    const dateString = firebaseDate.split(', ')[0];
    const day = +dateString.split('/')[0];
    const month = +dateString.split('/')[1];
    const year = +dateString.split('/')[2];
    return { year, month, day };
  }

  public getNgbTimeFromFirebaseTime(firebaseTime: string): NgbTimeStruct {
    const hour = +firebaseTime.split(':')[0];
    const minute = +firebaseTime.split(':')[1];
    return { hour, minute, second: 0 }
  }

  /**
   * Compare two NgbDateStruct dates.
   * @param date1
   * @param date2
   * @returns 0 if equal, -1 if date1 is older than date2, 1 if date1 is later than date2.
   */
  public compareNgbDates(date1: NgbDateStruct, date2) {
    const d1 = date1.year.toString() + date1.month.toString() + date1.day.toString();
    const d2 = date2.year.toString() + date2.month.toString() + date2.day.toString();

    if (d1 === d2) {
      return 0;
    }
    return d1 < d2 ? -1 : 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/_utils/utils.service.ts